document.addEventListener("DOMContentLoaded", function () {

  const videos = document.querySelectorAll(".vloxo-video");

  if (!videos.length) return;


  const observer = new IntersectionObserver(
    (entries)=>{

      entries.forEach((entry)=>{

        const video = entry.target;


        if(entry.isIntersecting){

          video.muted = true;
          video.setAttribute("playsinline","");

          let playPromise = video.play();


          if(playPromise !== undefined){

            playPromise.catch(()=>{

              video.load();
              video.play();

            });

          }


        }else{

          video.pause();

        }


      });


    },
    {
      threshold:0.25
    }
  );


  videos.forEach(video=>{

    observer.observe(video);

  });


});